import React from 'react';
import NumberFormat from 'react-number-format';
import { useField } from 'formik';

const FoodData = () => {
  return (
    <div className="food-data">
      <FoodItem
        fieldName="quantity_size"
        label="Serving Size"
        placeholder="Input Quantity"
      />
      <FoodItem
        fieldName="weight_grams"
        label="Grams"
        placeholder="Input Quantity"
      />
      <FoodItem
        fieldName="protein"
        label="Protein (g)"
        placeholder="Input Quantity"
      />
      <FoodItem fieldName="fat" label="Fat (g)" placeholder="Input Quantity" />
      <FoodItem
        fieldName="carbs"
        label="Carbs (g)"
        placeholder="Input Quantity"
      />
      <FoodItem
        fieldName="calories"
        label="Calories"
        placeholder="Input Quantity"
      />
    </div>
  );
};

const FoodItem = ({ fieldName, label, placeholder, isDecimal }) => {
  const [field, meta] = useField(fieldName);

  return (
    <div className="form-group">
      <label className="form-label" htmlFor={fieldName}>
        {label}
      </label>
      <NumberFormat
        type="text"
        allowNegative={false}
        decimalSeparator={isDecimal}
        className="form-control"
        placeholder={placeholder}
        {...field}
      />
      <FieldError meta={meta} />
    </div>
  );
};

const FieldError = ({ meta }) => {
  return meta.touched && meta.error ? (
    <div className="input-feedback">{meta.error}</div>
  ) : null;
};

export default FoodData;
